import { type ResponderNamesState } from './types';

export const initialState: ResponderNamesState = {
	responders: {},
};
